export default {
    name: "Careers",

    components: {},

    props: {},

    data: () => {
        return {
            jobs: [
                {
                    id: 1,
                    img: "img/client/broker_job.svg",
                    title: "ASISTENT ÎN BROKERAJ",
                    description: `- Pentru că iți place să faci bani: de la birou, de-acasă, de pe laptop sau de pe telefon!
                        - Pentru că vrei să investești doar seriozitate, perseverență, corectitudine și muncă!
                        - Pentru că vrei să fii propriul tău șef!
                        - Pentru că vrei să ai propria ta afacere!
                        - Pentru că iți dorești un magazin online!
                        - Pentru ca vrei să avansezi în carieră!
                        - Pentru că îți poți crea propria echipa!
                        - Pentru că vrei să iți organizezi singur timpul!
                        - Pentru că poți lucra de oriunde din țară!
                        - Pentru că nu te sperii de nou și inovație!

                        Cum?! Încă nu te-ai înscris?! Acționează acum! Vino în echipa PopularAsig! Vino alături de cei ca tine!
                        `
                }
            ],
            description: ""
        };
    },

    computed: {
        descriptionActive() {
            return this.description
                ? this.description
                : this.jobs[0].description;
        }
    },

    methods: {
        getJobDescription: function(id) {
            const elements = [
                ...document.getElementsByClassName("career__container")
            ];
            elements[id - 1].scrollIntoView({
                inline: "center",
                behavior: "smooth"
            });
            this.description = this.jobs.find(job => job.id === id).description;
        }
    }
};
